<div class="background-overlay"></div>
<div class="fullscreen-panel mobile-render-wrapper" fxLayout="column"   fxLayoutAlign="center center"  >
  <h2 class="label-title">Billing protection</h2>
  <div class="middle-layout" fxLayout="column" fxLayoutAlign="space-between center" >
    <p class="limit-title-msg">{{renderedModelsAmount}} models uploading during current billing period</p>
    <app-renderlimit-select [inputMaxElementsInRow]="5" (renderLimitChange)="onRenderLimitChange($event)"></app-renderlimit-select>
  </div>
</div>
